<template>
  <div class="category-tree-node" :class="{ 'category-tree-node--child': margin > 0 }">
    <div class="category-tree-node__row" :style="{'padding-right': `${margin}px`}">
      <button
          type="button"
          class="category-tree-node__item"
          @click="checkboxClicked(category)">
        <span class="category-tree-node__dot" aria-hidden="true"></span>
        <span class="category-tree-node__name">{{ category.name }}</span>
        <span class="category-tree-node__badge" v-if="hasChildren">زیردسته</span>
      </button>
    </div>

    <category
        :remove-category="removeCategory"
        :selected-category="selectedCategory"
        v-for="children in category.children"
        :margin="margin + 22"
        :key="children.id"
        :category="children"/>
  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "category",
  props: ['category', 'margin', 'selectedCategory', 'removeCategory'],
  computed: {
    hasChildren() {
      return Array.isArray(this.category.children) && this.category.children.length > 0
    }
  },
  methods: {
    checkboxClicked(category) {
      let ids = this.selectedCategory.map(item => item.id)
      if (ids.indexOf(category.id) === -1) {
        this.selectedCategory.push(category)
        toast('ایتم اضافه شد', 'ایتم اضافه شد')
      } else {
        toast('ایتم وجود دارد', 'ایتم وجود دارد', 'danger')
      }
    }
  }
}
</script>

<style scoped>
.category-tree-node--child {
  border-right: 2px solid rgba(235, 61, 96, 0.18);
  margin-right: 0.35rem;
}

.category-tree-node__row {
  margin-top: 0.35rem;
}

.category-tree-node__item {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 100%;
  padding: 0.35rem 0.55rem;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #424242;
  text-align: right;
  cursor: pointer;
}

.category-tree-node__item:hover {
  background: rgba(235, 61, 96, 0.08);
  color: #eb3d60;
}

.category-tree-node__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #eb3d60;
  flex: 0 0 auto;
}

.category-tree-node__name {
  font-weight: 600;
}

.category-tree-node__badge {
  font-size: 0.7rem;
  font-weight: 700;
  color: #eb3d60;
  background: rgba(235, 61, 96, 0.1);
  border-radius: 999px;
  padding: 0.1rem 0.45rem;
}
</style>
